import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { SpartanHelmet } from '@/components/icons/spartan-helmet'
import { Github, Twitter, Linkedin } from 'lucide-react'

export function Footer() {
  const { t } = useTranslation('landing')

  const sections = [
    {
      title: t('footer.product.title'),
      links: [
        { label: t('footer.product.agents'), href: '/login' },
        { label: t('footer.product.workflows'), href: '/login' },
        { label: t('footer.product.knowledge'), href: '/login' },
        { label: t('footer.product.pricing'), href: '/login' },
      ],
    },
    {
      title: t('footer.resources.title'),
      links: [
        { label: t('footer.resources.docs'), href: '#' },
        { label: t('footer.resources.api'), href: '#' },
        { label: t('footer.resources.guides'), href: '#' },
        { label: t('footer.resources.blog'), href: '#' },
      ],
    },
    {
      title: t('footer.company.title'),
      links: [
        { label: t('footer.company.about'), href: '#' },
        { label: t('footer.company.careers'), href: '#' },
        { label: t('footer.company.contact'), href: '#' },
        { label: t('footer.company.partners'), href: '#' },
      ],
    },
    {
      title: t('footer.legal.title'),
      links: [
        { label: t('footer.legal.privacy'), href: '/legal/privacy-policy.html' },
        { label: t('footer.legal.terms'), href: '/legal/terms-of-use.html' },
        { label: t('footer.legal.security'), href: '#' },
      ],
    },
  ]

  const socialLinks = [
    { icon: <Github className="w-5 h-5" />, href: '#', label: 'GitHub' },
    { icon: <Twitter className="w-5 h-5" />, href: '#', label: 'Twitter' },
    { icon: <Linkedin className="w-5 h-5" />, href: '#', label: 'LinkedIn' },
  ]

  return (
    <footer className="relative border-t border-gray-800 bg-gray-900/50">
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2 space-y-4">
            <div className="flex items-center gap-3">
              <SpartanHelmet className="w-8 h-8 text-indigo-400" />
              <span className="text-xl font-bold text-gradient-primary">ARCHON</span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed">
              {t('footer.description')}
            </p>
            <p className="text-gray-600 text-xs">{t('footer.tagline')}</p>
          </div>

          {/* Link sections */}
          {sections.map((section) => (
            <div key={section.title}>
              <h3 className="text-white font-semibold mb-4">{section.title}</h3>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('/') ? (
                      <Link
                        to={link.href}
                        className="text-gray-400 hover:text-indigo-400 text-sm transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="text-gray-400 hover:text-indigo-400 text-sm transition-colors"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 border-t border-gray-800">
          <p className="text-gray-500 text-sm">{t('footer.copyright')}</p>
          <div className="flex items-center gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                className="text-gray-500 hover:text-indigo-400 transition-colors"
                aria-label={social.label}
                target="_blank"
                rel="noopener noreferrer"
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
